<h1 mat-dialog-title class="titulo">{{data.titulo}}</h1>
<div mat-dialog-content>
  <mat-horizontal-stepper contenteditable="false"  class="centerPictures">
    <mat-step>
      <img class="img-fluid" src="assets/images/passo1.png" width="80%">
    </mat-step>
    <mat-step>
      <img class="img-fluid" src="assets/images/passo2.png" width="70%">
    </mat-step>
    <mat-step>
      <img class="img-fluid" src="assets/images/passo3.png" width="80%">
    </mat-step>
    <mat-step>
      <img class="img-fluid" src="assets/images/passo4.png" width="90%">
    </mat-step>
   
  </mat-horizontal-stepper>
</div>
<div mat-dialog-actions class="botoes">
  <button mat-raised-button class="md-icon-button btnNok" (click)="onClose()">
    <img class="img-fluid" src="assets/icons/white_close_icon.png"  width="16px"/> Fechar
  </button>
</div>